/**
 * RA宿泊・移動特約ありの場合の文字列
 */
export const ON_RA_LODGING_TRANSFER = '○'

/**
 * RA宿泊・移動特約ありの場合の文字列
 */
export const OFF_RA_LODGING_TRANSFER = '×'

/**
 * RA代車費用特約ありの場合の文字列
 */
export const ON_RA_LCAR_COST = '○'

/**
 * RA代車費用特約ありの場合の文字列
 */
export const OFF_RA_LCAR_COST = '×'
